"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var providers_1 = __importDefault(require("./providers"));
var tokens_1 = __importDefault(require("./tokens"));
exports.default = {
    version: "0.4",
    cacheApiUrl: "https://api.redstone.finance/prices",
    providers: providers_1.default,
    tokens: tokens_1.default,
};
